import {Injectable, OnDestroy} from "@angular/core";
import {IspmHttpClient} from "@ispm/core/services/ispm-http-client";
import {Store} from "@ngrx/store";
import {Observable, of, ReplaySubject} from "rxjs";
import {catchError, map, takeUntil} from "rxjs/operators";
import {BRANDS_URL} from "../constants";
import {IBrandData} from "../models/IBrandData";
import {SetBrandsAction, SetErrorAction} from "../store/brands.actions";
import {selectBrandById, selectBrandsArray} from "../store/brands.selectors";

@Injectable()
export class BrandsService implements OnDestroy {

  public brands$: Observable<IBrandData[]> = of([]);
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(private store: Store<any>, private _ispmHttp: IspmHttpClient) {

    this.fetchBrandsData().pipe(catchError((error) => {
        this.store.dispatch(new SetErrorAction({ error }));
        return of([]);
        }),
        map((brandsData) => {
            this.store.dispatch(new SetBrandsAction(brandsData as IBrandData[]));
        }))
        .subscribe();

    this.brands$ = this.store.select(selectBrandsArray).pipe(takeUntil( this.destroyed$));
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  
  fetchBrandsData(): Observable<IBrandData[]> {
    return this._ispmHttp.get<IBrandData[]>(`${BRANDS_URL}`);
  }

  getBrand(brandId: string): Observable<IBrandData> {
    return this.store.select(selectBrandById(brandId));
  }
}
